import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import { Info as InfoIcon } from '@mui/icons-material';
import Text from '../Text.js';
import Button from '../Button.js';
import { useTheme } from '@mui/material/styles';

/**
 * @param testid
 * @param title
 * @param subtitle
 * @param paragraph
 * @param classes
 * @param btnsAbove
 * @param formatted
 * @param checkbox
 * @param checked
 * @param btnName
 * @param btn
 * @param btnOnClick
 * @param btnCustomStyle
 * @param btnName2
 * @param btn2
 * @param btnOnClick2
 * @param btnCustomStyle2
 * @param isError
 * @param onChangeCheckbox
 * @returns {JSX.Element}
 * @constructor
 */
const MessageCard = ({
  testid,
  title,
  subtitle,
  paragraph,
  classes,
  btnsAbove,
  formatted,
  checkbox,
  checked,
  btnName,
  btn,
  btnOnClick,
  btnCustomStyle,
  btnName2,
  btn2,
  btnOnClick2,
  btnCustomStyle2,
  isError = false,
  onChangeCheckbox
}) => {
  const theme = useTheme();

  /**
   * @param theme
   */
  const styles = {
    flexBlock: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    subtitleBlock: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'baseline'
    },
    checkBlock: {
      display: 'block'
    },
    cardStyle: {
      display: 'flex',
      flex: 1,
      backgroundColor: theme.palette.primary.light,
      boxShadow: 'none',
      padding: 20,
      minHeight: 35,
      flexDirection: 'row',
      borderLeft: 'solid',
      borderLeftWidth: 5,
      borderColor: theme.palette.primary.main
    },
    small: {
      maxWidth: 1000
    },
    btnStyle: {
      width: 'fit-content'
    },
    icon: {
      color: isError ? '#DA3328' : theme.palette.primary.main
    }
  };

  /**
   * 
   * @returns 
   */
  const setErrorStyling = element => {
    if (isError && element === "div") {
      return {
        backgroundColor: '#FCE8E6',
        borderColor: '#DA3328'
      };
    }
    if (isError && element === "button") {
      return {
        borderColor: '#DA3328'
      };
    }
    return null;
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      margin: "24px 0",
      flex: 1
    }
  }, btn && btnsAbove && /*#__PURE__*/React.createElement("div", {
    style: {
      ...styles.flexBlock,
      marginBottom: 10
    }
  }, btn2 && /*#__PURE__*/React.createElement(Button, {
    testid: testid,
    customStyle: {
      ...styles.btnStyle,
      ...btnCustomStyle2,
      ...setErrorStyling("button")
    },
    onClick: btnOnClick2,
    transparent: true
  }, btnName2), /*#__PURE__*/React.createElement(Button, {
    testid: testid,
    color: "primary",
    customStyle: {
      ...styles.btnStyle,
      ...btnCustomStyle,
      ...setErrorStyling("button")
    },
    onClick: btnOnClick
  }, btnName)), /*#__PURE__*/React.createElement("div", {
    style: {
      ...styles.cardStyle,
      ...setErrorStyling("div")
    }
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    sx: styles.icon,
    size: 20
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: 20,
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testid: testid,
    align: "left",
    mediumLarge: true,
    bold: true,
    display: "block",
    margin: "0 0 5px 0"
  }, title), /*#__PURE__*/React.createElement("div", {
    style: styles.subtitleBlock
  }, checkbox && /*#__PURE__*/React.createElement("div", {
    style: styles.checkBlock
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: checked,
    onChange: onChangeCheckbox,
    color: "primary"
  })), subtitle && /*#__PURE__*/React.createElement(Text, {
    align: "left",
    medium: true,
    display: "block",
    formatted: formatted
  }, subtitle)), paragraph && /*#__PURE__*/React.createElement(Text, {
    align: "left",
    small: true,
    margin: "20px 0px 20px 0px",
    display: "block"
  }, paragraph))), btn && !btnsAbove && /*#__PURE__*/React.createElement("div", {
    style: {
      ...styles.flexBlock,
      marginTop: 10
    }
  }, btn2 && /*#__PURE__*/React.createElement(Button, {
    testid: testid,
    customStyle: {
      ...styles.btnStyle,
      ...btnCustomStyle2,
      ...setErrorStyling("button")
    },
    onClick: btnOnClick2,
    transparent: true
  }, btnName2), /*#__PURE__*/React.createElement(Button, {
    testid: testid,
    color: "primary",
    onClick: btnOnClick,
    customStyle: {
      ...styles.btnStyle,
      ...btnCustomStyle,
      ...setErrorStyling("button")
    }
  }, btnName)));
};
export default MessageCard;